<pp-modal>
  <ng-container heading>
    <div ppTooltip [ppTrimTooltip]="true">
      <strong>{{ siteName }}</strong>
    </div>
  </ng-container>

  <ng-container body>
    <form class="modalNotifications" name="shareForm" novalidate="" (submit)="save()">
      <h5 class="modal__body-title">
        {{ 'email_notification_frequency' | ppTranslate }}
      </h5>
      @for (sub of subscriptionTypes; track sub) {
        <div class="modalNotifications__radio">
          <pp-radio
            [ppChecked]="sub.value === subscriptionType"
            (ppOnValueChange)="toggleSubscriptionType(sub)"
            ppStyle="blue"
            >
            <label class="control-custom control-custom--radio">
              {{ sub.label | ppTranslate }}
            </label>
          </pp-radio>
        </div>
      }
    </form>
  </ng-container>

  <ng-container footer>
    <pp-button-modal-cancel ppId="modalCancelButton" (ppAction)="hideModal()">
      {{ 'cancel' | ppTranslate }}
    </pp-button-modal-cancel>

    <div class="modalFooter__right">
      @if (!isBulkEdit) {
        <pp-button-modal-confirm
          ppTooltip
          [ppTitle]="'apply_to_all_sites' | ppTranslate"
          (ppAction)="saveBulk()"
          [ppDisabled]="!subscriptionType"
          [ppProcess]="processing"
          [ppStyle]="'secondary'"
          >
          {{ 'apply_to_all_sites' | ppTranslate }}
        </pp-button-modal-confirm>
      }

      <pp-button-modal-confirm
        ppTooltip
        [ppTitle]="(isBulkEdit ? 'save_for_all' : 'save') | ppTranslate"
        (ppAction)="save()"
        [ppDisabled]="!subscriptionType"
        [ppProcess]="processing"
        >
        {{ (isBulkEdit ? 'save_for_all' : 'save') | ppTranslate }}
      </pp-button-modal-confirm>
    </div>
  </ng-container>
</pp-modal>
